var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { json } from 'overmind';
import Slider from 'components/Slider.vue';
import CurrencyInput from 'components/CurrencyInput.vue';
import { isEqual } from 'lodash';
import { mixpanelTracking } from '@/services/mixpanel';
import { differenceBetweenCnpjAndCompanyTooltip, formatCurrency, } from '@/shared/utils/helpers';
let Revenue = class Revenue extends Vue {
    constructor() {
        super(...arguments);
        this.sliderValue = json(this.stateSliderFiltersValues.revenues);
        this.radioButtonValue = this.radioButton;
        this.showOptionInput = false;
        this.inputValueInitial = null;
        this.inputValueEnd = null;
        this.savedSliderValue = null;
    }
    created() {
        this.syncInputsWithState();
        if (this.inputValueInitial !== null && this.inputValueEnd !== null) {
            this.showOptionInput = true;
        }
    }
    toggleMode() {
        this.showOptionInput = !this.showOptionInput;
        if (this.showOptionInput) {
            // Entrando em modo aproximado: salva o estado do slider e limpa só os inputs
            this.savedSliderValue = [...this.sliderValue.value];
            this.inputValueInitial = null;
            this.inputValueEnd = null;
            this.$emit('setInputsRange', {
                value_start: null,
                value_end: null,
                queryField: this.radioButtonValue,
                groupTag: 'porte',
            });
        }
        else {
            // Voltando para slider: restaura o estado salvo do slider
            this.inputValueInitial = null;
            this.inputValueEnd = null;
            this.$emit('setInputsRange', {
                value_start: null,
                value_end: null,
                queryField: this.radioButtonValue,
                groupTag: 'porte',
            });
            if (this.savedSliderValue) {
                this.sliderValue.value = this.savedSliderValue;
                const isDefault = this.savedSliderValue[0] === '0' &&
                    this.savedSliderValue[1] === '+500M';
                if (!isDefault) {
                    this.$emit('setSliderFilter', {
                        groupTagFilter: this.filter.groupTag,
                        queryField: this.filter.queryField,
                        value: this.savedSliderValue,
                    });
                }
                this.savedSliderValue = null;
            }
        }
    }
    syncInputsWithState() {
        const range = this.selectedInputRange[this.radioButtonValue];
        if (range) {
            this.inputValueInitial = range.value_start;
            this.inputValueEnd = range.value_end;
        }
    }
    setinputValueInitial(value) {
        this.inputValueInitial = value;
        const startValue = this.inputValueInitial !== null ? this.inputValueInitial : 0;
        if (this.inputValueEnd !== null && startValue <= this.inputValueEnd) {
            this.$emit('setInputsRange', {
                value_start: startValue,
                value_end: this.inputValueEnd,
                queryField: this.radioButtonValue,
                groupTag: 'porte',
            });
        }
        else {
            this.$emit('setInputsRange', {
                value_start: null,
                value_end: null,
                queryField: this.radioButtonValue,
                groupTag: 'porte',
            });
        }
    }
    setinputValueEnd(value) {
        this.inputValueEnd = value;
        const startValue = this.inputValueInitial !== null ? this.inputValueInitial : 0;
        if (this.inputValueEnd !== null && startValue <= this.inputValueEnd) {
            this.$emit('setInputsRange', {
                value_start: startValue,
                value_end: this.inputValueEnd,
                queryField: this.radioButtonValue,
                groupTag: 'porte',
            });
        }
        else {
            this.$emit('setInputsRange', {
                value_start: null,
                value_end: null,
                queryField: this.radioButtonValue,
                groupTag: 'porte',
            });
        }
    }
    setSelectedRadioButton(queryField, from) {
        this.$emit('setSelectedRadioButton', { queryField, from });
        this.radioButtonValue = queryField;
        this.syncInputsWithState();
    }
    clearFilter() {
        this.inputValueInitial = null;
        this.inputValueEnd = null;
        this.$emit('setInputsRange', {
            value_start: null,
            value_end: null,
            queryField: this.radioButtonValue,
            groupTag: 'porte',
        });
        if (this.sliderValue &&
            this.sliderValue.label &&
            this.sliderValue.label.length > 0) {
            const defaultRange = [
                this.sliderValue.label[0],
                this.sliderValue.label[this.sliderValue.label.length - 1],
            ];
            this.sliderValue.value = defaultRange;
            this.$emit('setSliderFilter', {
                groupTagFilter: this.filter.groupTag,
                queryField: this.filter.queryField,
                value: defaultRange,
            });
        }
    }
    validSliderFilter(event) {
        if (event.value[0] === event.value[1]) {
            this.$emit('setErrorSliderFilter', {
                type: event.groupTagFilter,
                action: 'error',
            });
            this.$emit('setSliderFilter', event);
        }
        else {
            this.$emit('setErrorSliderFilter', {
                type: event.groupTagFilter,
                action: 'success',
            });
            if (event.value[0] !== event.value[1] && event.value[1] !== '0') {
                this.inputValueInitial = null;
                this.inputValueEnd = null;
                this.$emit('setInputsRange', {
                    value_start: null,
                    value_end: null,
                    queryField: this.radioButtonValue,
                    groupTag: 'porte',
                });
                this.$emit('setSliderFilter', event);
            }
        }
    }
    get selectedInfo() {
        const range = this.selectedInputRange[this.radioButtonValue];
        if (range && range.value_start !== null && range.value_end !== null) {
            return `(${formatCurrency(range.value_start)} a ${formatCurrency(range.value_end)})`;
        }
        if (this.selectedCount(this.filter) === 1) {
            return '(1 selecionado)';
        }
        return '';
    }
    selectedCount(filter) {
        const range = this.selectedInputRange[this.radioButtonValue];
        if (range && range.value_start !== null && range.value_end !== null) {
            return 1;
        }
        if (filter.queryType === 'rangeSlider' &&
            filter.groupTag === 'Faturamento') {
            const isValueDefault = isEqual(this.sliderValue.value, ['0', '+500M']);
            if ((this.sliderValue.value[0] == 0 && this.sliderValue.value[1] == 0) ||
                isValueDefault) {
                return 0;
            }
            else {
                return 1;
            }
        }
    }
    getSliderStyle() {
        if (this.errorSlider) {
            return {
                color: 'red',
            };
        }
    }
    handleTrackingRevenue() {
        mixpanelTracking('filtros avançados: Expandiu o grupo de filtros: ' + this.filterName);
    }
    tooltipCopy(label) {
        return differenceBetweenCnpjAndCompanyTooltip(label);
    }
    onSelectedInputRangeChange() {
        this.syncInputsWithState();
    }
};
__decorate([
    Prop({ default: () => { } })
], Revenue.prototype, "filter", void 0);
__decorate([
    Prop({ default: () => { } })
], Revenue.prototype, "stateSliderFiltersValues", void 0);
__decorate([
    Prop({ default: () => ({}) })
], Revenue.prototype, "selectedInputRange", void 0);
__decorate([
    Prop({ default: '' })
], Revenue.prototype, "filterName", void 0);
__decorate([
    Prop({ default: '' })
], Revenue.prototype, "radioButton", void 0);
__decorate([
    Prop({ default: false })
], Revenue.prototype, "errorSlider", void 0);
__decorate([
    Watch('selectedInputRange', { deep: true })
], Revenue.prototype, "onSelectedInputRangeChange", null);
Revenue = __decorate([
    Component({
        components: {
            Slider,
            CurrencyInput,
        },
    })
], Revenue);
export default Revenue;
